import * as RestrictionsStep from './RestrictionsStep/RestrictionsStep.css';

export default {
	RestrictionsStep
};
